// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"31":"f9cd9b31","151":"2bc1fd98","315":"ab557e45","382":"eb7da721","658":"683a6774","998":"5a2bc767"}[chunkId] + ".chunk.js";
};